import { Component, OnInit, Input } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import {
  DialogResponse,
  VS_LAUNCH_CALLER,
} from '../../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'vs-quote-edit-dialog',
  templateUrl: './quote-edit-dialog.component.html',
  styleUrls: ['./quote-edit-dialog.component.scss'],
})
export class QuoteEditDialogComponent implements OnInit {
  constructor(private launchDialogService: LaunchDialogService) {}
  ngOnInit(): void {
    this.launchDialogService.data$.subscribe((data) => {})
  }

  closeModal(reasonForRejection): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.QUOTE_EDIT,
      reason: reasonForRejection,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
